import { render, staticRenderFns } from "./editClientInActivityDetail.vue?vue&type=template&id=3c79dea6&scoped=true&"
import script from "./editClientInActivityDetail.vue?vue&type=script&lang=js&"
export * from "./editClientInActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79dea6",
  null
  
)

export default component.exports